


































import { Component, Prop, Watch, Emit, Vue } from 'vue-property-decorator'

import MultiSelect from 'primevue/multiselect'
import AppColorTag from '@/components/AppColorTag'

Vue.component('MultiSelect', MultiSelect)
Vue.component('AppColorTag', AppColorTag)

@Component
export default class AssigneeSelector extends Vue {
  @Prop() model!: any[]
  @Prop() options!: any[]
  @Prop() customClasses!: string

  // flag to work around issue with hide being
  //  called when component mounts
  hasHiddenOnceAlready = false

  @Watch('model')
  modelChanged (newValue: any) {
    this.selectionsChanged(newValue)
  }

  @Emit()
  selectionsChanged (newValue: any) {
    return newValue
  }

  @Emit()
  hide () {
    const result = this.hasHiddenOnceAlready
    this.hasHiddenOnceAlready = true
    return result
  }
}
